// extracted by mini-css-extract-plugin
export default {"loginWrapper":"authScreen_loginWrapper__x60vA","loginForm":"authScreen_loginForm__WZf94","regButton":"authScreen_regButton__ooMrY","loginBtn":"authScreen_loginBtn__++je3"};